import { z } from 'zod';

// ─── State ──────────────────────────────────────────────────────────────────

/**
 * The canonical XState snapshot persisted in the `state` JSONB column.
 * Initially empty — extend this type as the machine grows.
 */
export interface MessageGenState {}

// ─── Session Schema ─────────────────────────────────────────────────────────

export const MessageGenSessionSchema = z.object({
  id: z.number(),
  sessionId: z.string(),
  state: z.record(z.string(), z.unknown()).transform((v) => v as MessageGenState),
  createdOn: z.date(),
  createdBy: z.number(),
});

export type MessageGenSession = z.infer<typeof MessageGenSessionSchema>;

// ─── Create Session ─────────────────────────────────────────────────────────

export const CreateMessageGenSessionRequestSchema = z.object({
  sessionId: z.string().min(1),
});

export type CreateMessageGenSessionRequest = z.infer<typeof CreateMessageGenSessionRequestSchema>;

// ─── Send Event ─────────────────────────────────────────────────────────────

export const MessageGenSessionEventRequestSchema = z.object({
  sessionId: z.string().min(1),
  event: z
    .object({
      type: z.string().min(1),
    })
    .passthrough(),
});

export type MessageGenSessionEventRequest = z.infer<typeof MessageGenSessionEventRequestSchema>;
